import { create } from 'zustand'

import type { DisplayStatus, Widget } from '~/common/@types'

type AppState = {
  widget?: Widget
  setWidget: (widget: Widget) => void
  displayStatus?: DisplayStatus
  setDisplayStatus: (open: DisplayStatus) => void
}

const useApp = create<AppState>(set => ({
  widget: undefined,
  setWidget: widget => set({ widget }),
  displayStatus: undefined,
  setDisplayStatus: displayStatus => set({ displayStatus }),
}))

export default useApp
